/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

/**
 * @public
 * An empty function useful when dealing with callbacks. Commonly used in functional programing.
 * You can use this empty function when you wish to pass around a function that will do nothing.
 */
const noop = () => {};

export default noop;
